import * as React from "react";
import {
  Box,
  CircularProgress,
  Divider,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  useMediaQuery,
  ListItem,
  Popover,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Radio,
  Checkbox,
  ListItemText,
  Button,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SubSellerFilter from "../filters/subSellerFilter";
import { useDispatch, useSelector } from "react-redux";
import useInfiniteScroll from "react-infinite-scroll-hook";
import { useTheme } from "@emotion/react";
import {
  backToSubseller,
  getCSVData,
  getSearchedSubSellers,
  resetAll,
  setPage,
} from "../../redux/slices/subSellerSlice";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { STATUSSUBSELLERMAPPING } from "../../utils/constants";
import {
  formatDate,
  getSubtitleSubSellerStatus,
  showProperDate1,
} from "../../utils";
import {
  getAllGdsAggregator,
  getAllStatuses,
} from "../../redux/slices/subSellerSlice";
import { useNavigate } from "react-router-dom";
import { ROLES } from "../../utils/constants";

const DROPDOWN_HEIGHT = 200;

const SubSellerList = ({ subSellerTab }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();

  const state = useSelector(
    ({
      subSeller: {
        searchedSubSellers,
        statuses,
        gdsAggregator,
        loading,
        isInput,
        page,
        searchTerm,
        hasNextPage,
        matchingResults,
        backToSubseller,
      },
      seller: {
        msal: { roles },
      },
    }) => ({
      searchedSubSellers,
      statuses,
      gdsAggregator,
      loading,
      isInput,
      page,
      searchTerm,
      hasNextPage,
      matchingResults,
      backToSubseller,
      roles,
    })
  );

  const [filterStatus, setFilterStatus] = React.useState("SSS001");
  const [filterGdsAggregator, setFilterGdsAggregator] = React.useState("ALL");

   // New state for export dropdown
  const [exportAnchorEl, setExportAnchorEl] = React.useState(null);
  const exportTriggerRef = React.useRef(null);
  const firstFocusableRef = React.useRef(null);
  const [selectedStatuses, setSelectedStatuses] = React.useState([]);
  const [selectedGdsAggregators, setSelectedGdsAggregators] = React.useState([]);
  const [allStatusSelected, setAllStatusSelected] = React.useState(true);
  const [allGdsSelected, setAllGdsSelected] = React.useState(true);

  // React.useEffect(() => {
  //   dispatch(resetAll());
  //   if(subSellerTab) {
  //     dispatch(getSearchedSubSellers({
  //       params: { status: "SSS001", seller_id:'ALL', offset: 0 },
  //       isInput: false
  //     }))
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  React.useEffect(() => {
    dispatch(getAllStatuses());
    dispatch(getAllGdsAggregator());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (state.page > 0) {
      fetchSeller();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.page]);

  const isMobile = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "md")
  );
  const isTablet = useMediaQuery((theme) =>
    theme.breakpoints.between("md", "lg")
  );

  const fetchSeller = (selectStatusId, selectSellerId, flag = false) => {
    const params = {
      ...(state.isInput
        ? { searchTerm: state.searchTerm }
        : {
            status: selectStatusId || filterStatus,
            seller_id: selectSellerId || filterGdsAggregator,
          }),
      offset: flag ? 0 : state.page,
    };
    dispatch(
      getSearchedSubSellers({
        params,
        isInput: state.isInput,
      })
    );
  };

  const [sentryRef] = useInfiniteScroll({
    loading: state.loading,
    hasNextPage: state.hasNextPage,
    onLoadMore: () => dispatch(setPage()),
    rootMargin: "400px 0px 0px 0px",
  });

  React.useEffect(() => {
    fetchSeller();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (subSellerTab) {
      // clearFilter()
      const flag = false;
      const params = {
        status: filterStatus,
        seller_id: filterGdsAggregator,
        offset: flag ? 0 : state.page,
      };
      dispatch(
        getSearchedSubSellers({
          params,
          isInput: false,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subSellerTab]);

  const handleStatusChange = (e) => {
    dispatch(resetAll());
    fetchSeller(e.target.value, filterGdsAggregator, true);
    setFilterStatus(e.target.value);
  };

  React.useEffect(() => {
    if (state.backToSubseller) {
      dispatch(backToSubseller(false));
      dispatch(resetAll());
      setFilterStatus("SSS001");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.backToSubseller]);

  const handleSellerIdChange = (e) => {
    dispatch(resetAll());
    fetchSeller(filterStatus, e.target.value, true);
    setFilterGdsAggregator(e.target.value);
  };

  const handleSellerClick = (id) => {
    navigate(`/subseller/${id}`);
    // setShowModal(id);
  };

  const clearFilter = () => {
    setFilterStatus("SSS001");
    setFilterGdsAggregator("ALL");
  };

  const displayFilterStatus = (_filterStatus) => {
    switch (_filterStatus) {
      case "Pending":
        return `${_filterStatus} Approval (${
          state?.statuses?.pending_count || 0
        })`;
      case "Rejected":
        return `${_filterStatus} (${state?.statuses?.rejected_count || 0})`;
      case "Approved":
        return `${_filterStatus} (${state?.statuses?.approved_count || 0})`;
      default:
        return null;
    }
  };

  const isExportOpen = Boolean(exportAnchorEl);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
    setAllStatusSelected(true);
    setSelectedStatuses([]);
    setAllGdsSelected(true);
    setSelectedGdsAggregators([]);
    // Restore focus to trigger
    exportTriggerRef.current?.focus();
  };

  const handleExportSubmit = () => {
  const statusIds = allStatusSelected ? ['ALL'] 
    : selectedStatuses.map((status) => {
      const statusObj = state.statuses.status.find(s => s.status_en === status);
      return statusObj ? statusObj.sub_seller_status_id : null;
    }).filter(Boolean);

  const gdsIds = allGdsSelected ? ['ALL'] 
    : selectedGdsAggregators.map((gds) => {
      const gdsObj = state.gdsAggregator.data.find(g => g.company_name === gds);
      return gdsObj ? gdsObj.seller_id : null;
    }).filter(Boolean);


  dispatch(getCSVData({
    status: statusIds.join(','),
    seller_id: gdsIds.join(','),
  }));

  handleExportClose();
};

  React.useEffect(() => {
    if (isExportOpen) {
      // Focus first focusable (Submit button)
      firstFocusableRef.current?.focus();
    }
  }, [isExportOpen]);

  const handleStatusAllChange = () => {
    setAllStatusSelected(true);
    setSelectedStatuses([]);
  };

  const handleGdsAllChange = () => {
    setAllGdsSelected(true);
    setSelectedGdsAggregators([]);
  };

  const handleDownloadStatusChange = (value, checked) => {
    if (checked) {
      setSelectedStatuses((prev) => {
        const next = [...prev, value];
        setAllStatusSelected(false);
        return next;
      });
    } else {
      setSelectedStatuses((prev) => {
        const next = prev.filter((item) => item !== value);
        if (next.length === 0) setAllStatusSelected(true);
        return next;
      });
    }
  };

  const handleGdsChange = (value, checked) => {
    if (checked) {
      setSelectedGdsAggregators((prev) => {
        const next = [...prev, value];
        setAllGdsSelected(false);
        return next;
      });
    } else {
      setSelectedGdsAggregators((prev) => {
        const next = prev.filter((item) => item !== value);
        if (next.length === 0) setAllGdsSelected(true);
        return next;
      });
    }
  };

  return (
    <>
      <SubSellerFilter clearFilter={clearFilter} subSellerTab={subSellerTab} />

      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile || isTablet ? "column" : "row",
          columnGap: 5,
          mb: 7,
          flex: 1,
        }}
      >
        {state.isInput ? (
          <Box sx={{ display: "flex", flexDirection: "column", flex: 0.7 }}>
            <ListItem
              elevation={4}
              sx={{
                cursor: "pointer",
                fontFamily: "Open Sans",
                borderRadius: 3,
                fontWeight: 600,
                pb: 2,
                ...(!(isMobile || isTablet) && {
                  p: 1.5,
                  boxShadow: "0 0 1rem #ccc",
                  pl: 2,
                  bgcolor: theme.palette.primary.contrastText,
                }),
                color: theme.palette.navbarBg,
              }}
            >
              {`Matching Results (${state.matchingResults})`}
            </ListItem>
          </Box>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", flex: 0.7 }}>
            <FormControl variant="standard" sx={{ mb: 4 }}>
              <InputLabel
                id="selectedStatus"
                sx={{
                  fontSize: "1rem",
                  fontWeight: 400,
                  lineHeight: "1.25rem",
                  color: theme.palette.navbarBg,
                }}
              >
                Filter By Status
              </InputLabel>
              <Select
                labelId="selectedStatus"
                size="small"
                value={filterStatus}
                onChange={handleStatusChange}
                sx={{
                  bgcolor: "inherit",
                  fontWeight: 600,
                  mr: isMobile ? 0 : "5rem",
                  py: ".4rem",
                }}
              >
                {state?.statuses?.status?.map((ft) => (
                  <MenuItem
                    key={ft.sub_seller_status_id}
                    value={ft.sub_seller_status_id}
                  >
                    {displayFilterStatus(ft.status_en)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="standard" sx={{ mb: 1 }}>
              <InputLabel
                id="selectedStatus"
                sx={{
                  fontSize: "1rem",
                  fontWeight: 400,
                  lineHeight: "1.25rem",
                  color: theme.palette.navbarBg,
                }}
              >
                Filter By GDS/Aggregator
              </InputLabel>
              <Select
                labelId="selectedStatus"
                size="small"
                value={filterGdsAggregator}
                onChange={handleSellerIdChange}
                sx={{
                  bgcolor: "inherit",
                  fontWeight: 600,
                  mr: isMobile ? 0 : "5rem",
                  py: ".4rem",
                }}
                MenuProps={{
                  color: theme.palette.silverSand,
                  PaperProps: {
                    sx: {
                      maxHeight: DROPDOWN_HEIGHT,
                    },
                  },
                }}
              >
                <MenuItem value="ALL">Show all</MenuItem>
                {state?.gdsAggregator?.data?.map((ft) => (
                  <MenuItem key={ft.seller_id} value={ft.seller_id}>
                    {ft.company_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 2,
            overflowY: "scroll",
            height: "90vh",
          }}
        >
          {state.roles.some(
            (role) =>
              role === ROLES.SUPER_ADMIN ||
              role === ROLES.BUSINESS_ADMIN ||
              role === ROLES.BUSINESS_USER
          ) ? (
            <Typography
              ref={exportTriggerRef}
              role="button"
              tabIndex={0}
              aria-haspopup="dialog"
              aria-expanded={isExportOpen}
              aria-controls={isExportOpen ? 'export-popover' : undefined}
              onClick={handleExportClick}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleExportClick(e);
                }
              }}
              sx={{
                display: "flex",
                alignSelf: "end",
                color: theme.palette.darkBlue,
                cursor: "pointer",
                pr: 0.5,
              }}
            >
              <SaveAltIcon sx={{ color: theme.palette.icon }} />
              &nbsp; Export Sub-Sellers
            </Typography>
          ) : null}

          <>
            {state.searchedSubSellers.map((data, index) => (
              <Box key={data.seller_id} sx={{ mb: 2 }}>
                <Grid
                  container
                  sx={{
                    display: "flex",
                    ...(!state.isInput && { mt: 2 }),
                    borderRadius: 4,
                    bgcolor: theme.palette.primary.contrastText,
                  }}
                >
                  <Grid item xs={10} md={4} sx={{ p: "1.5rem 0 2rem 1.5rem" }}>
                    <Typography
                      variant="h6"
                      fontWeight={"600"}
                      fontSize={"1.25rem"}
                      lineHeight={"1.625rem"}
                      gutterBottom
                    >
                      {data.travel_agency_name}
                    </Typography>
                    <Typography
                      sx={{ fontSize: "0.875rem" }}
                      color="#000000"
                      fontWeight={"400"}
                      gutterBottom
                    >
                      {`${data.seller_id} - ${data.business_type_en}`}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: ".875rem",
                        fontWeight: "400",
                        lineHeight: "1.375rem",
                        color: theme.palette[data.sub_seller_status_id],
                      }}
                      color={theme.palette.darkBlue}
                    >
                      {STATUSSUBSELLERMAPPING[data.sub_seller_status_id]}
                      &nbsp;&#124;
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: ".875rem",
                        fontWeight: "400",
                        lineHeight: "1.375rem",
                      }}
                      color={theme.palette.navbarBg}
                      gutterBottom
                    >
                      {`${getSubtitleSubSellerStatus(
                        data?.sub_seller_status_id
                      )} 
                        ${formatDate(
                          showProperDate1(data?.sub_seller_status_id)
                            ? data?.created_date
                            : data?.modification_date
                        )}`}
                    </Typography>
                  </Grid>

                  {!isMobile && (
                    <Grid
                      item
                      md={1}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        py: 2,
                      }}
                    >
                      <Divider orientation="vertical" variant="fullWidth" />
                    </Grid>
                  )}

                  {!isMobile && (
                    <Grid item md={6} sx={{ py: "1.5rem" }}>
                      <Typography
                        sx={{
                          fontSize: ".75rem",
                          lineHeight: "1.125rem",
                          fontWeight: "400",
                        }}
                        color={theme.palette.greyText}
                        gutterBottom
                      >
                        Agency Website
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: ".875rem",
                          lineHeight: "1.375",
                          fontWeight: "400",
                        }}
                        color={theme.palette.navbarBg}
                      >
                        {data.agency_website}
                      </Typography>
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={2}
                    md={1}
                    tabIndex={0}
                    onKeyUp={(e) =>
                      !e.shiftKey &&
                      (e.key === "Enter" || e.key === " ") &&
                      handleSellerClick(data.sub_seller_id)
                    }
                    sx={{ alignSelf: "stretch", cursor: "pointer" }}
                    onClick={() => handleSellerClick(data.sub_seller_id)}
                  >
                    <NavigateNextIcon
                      sx={{ color: theme.palette.icon, height: "100%" }}
                      fontSize="large"
                    />
                  </Grid>
                </Grid>

                {state.searchedSubSellers.length - 1 === index &&
                  state.searchedSubSellers.length >= 6 &&
                  state.hasNextPage && (
                    <Box
                      ref={sentryRef}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        py: "2rem",
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  )}
              </Box>
            ))}
            {state.loading &&
            !state.isInput &&
            !state.searchedSubSellers.length ? (
              <CircularProgress sx={{ m: "0 auto" }} />
            ) : null}
            {!state.searchedSubSellers.length &&
              !state.loading &&
              !(isMobile || isTablet) && (
                <Typography textAlign={"center"}>
                  There are no sub-sellers matching this status.
                </Typography>
              )}
          </>
        </Box>
      </Box>

      <Popover
        id="export-popover"
        open={isExportOpen}
        anchorEl={exportAnchorEl}
        onClose={handleExportClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            width: '300px',
            maxHeight: '400px',
            overflowY: 'auto',
            '& .MuiAccordion-root': {
              boxShadow: 'none',
              '&:before': { display: 'none' },
              m: 0,
            },
          },
        }}
      >
        <Box
          role="group"
          onKeyDown={(e) => {
            // Keep popover open on Tab; allow normal tab navigation
            if (e.key === 'Escape') {
              e.stopPropagation();
              handleExportClose();
            }
          }}
        >
          <Accordion defaultExpanded sx={{ p: 0 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: '#000000' }} />}
              sx={{
                backgroundColor: "#F1F7FB",
                minHeight: "56px !important",
                '& .MuiAccordionSummary-content': { m: '0 !important' },
                '& .MuiAccordionSummary-content.Mui-expanded': { m: '0 !important' },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontFamily: "Open Sans",
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "24px",
                  color: "#000000",
                }}
              >
                Status
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              <MenuItem
                sx={{ p: 0 }}
                onClick={handleStatusAllChange}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleStatusAllChange();
                  }
                }}
              >
                <Radio
                  sx={{ color: "#1460AA" }}
                  checked={allStatusSelected}
                  onChange={handleStatusAllChange}
                />
                <ListItemText
                  primary="ALL"
                  sx={{ fontFamily: 'Open Sans', fontWeight: 400, fontSize: '14px', lineHeight: '20px' }}
                />
              </MenuItem>
              {state?.statuses?.status?.map((option) => (
                <MenuItem
                  key={option.status_en}
                  sx={{ p: 0 }}
                  onClick={() =>
                    handleDownloadStatusChange(option.status_en, !selectedStatuses.includes(option.status_en))
                  }
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleDownloadStatusChange(option.status_en, !selectedStatuses.includes(option.status_en));
                    }
                  }}
                >
                  <Checkbox
                    sx={{ color: "#1460AA" }}
                    checked={selectedStatuses.includes(option.status_en)}
                    onChange={(e) => handleDownloadStatusChange(option.status_en, e.target.checked)}
                  />
                  <ListItemText
                    primary={option.status_en === 'Pending' ? 'Pending Approval' : option.status_en}
                    sx={{
                      fontFamily: 'Open Sans',
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '20px',
                    }}
                  />
                </MenuItem>
              ))}
            </AccordionDetails>
          </Accordion>

          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: '#000000' }} />}
              sx={{
                backgroundColor: "#F1F7FB",
                minHeight: "56px !important",
                '& .MuiAccordionSummary-content': { m: '0 !important' },
                '& .MuiAccordionSummary-content.Mui-expanded': { m: '0 !important' },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontFamily: "Open Sans",
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "24px",
                  color: "#000000",
                }}
              >
                GDS/Aggregator
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              <MenuItem
                sx={{ p: 0 }}
                onClick={handleGdsAllChange}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleGdsAllChange();
                  }
                }}
              >
                <Radio
                  sx={{ color: "#1460AA" }}
                  checked={allGdsSelected}
                  onChange={handleGdsAllChange}
                />
                <ListItemText
                  primary="ALL"
                  sx={{ fontFamily: 'Open Sans', fontWeight: 400, fontSize: '14px', lineHeight: '20px' }}
                />
              </MenuItem>
              {state?.gdsAggregator?.data?.map((option) => (
                <MenuItem
                  key={option.company_name}
                  sx={{ p: 0 }}
                  onClick={() =>
                    handleGdsChange(option.company_name, !selectedGdsAggregators.includes(option.company_name))
                  }
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleGdsChange(option.company_name, !selectedGdsAggregators.includes(option.company_name));
                    }
                  }}
                >
                  <Checkbox
                    sx={{ color: "#1460AA" }}
                    checked={selectedGdsAggregators.includes(option.company_name)}
                    onChange={(e) => handleGdsChange(option.company_name, e.target.checked)}
                  />
                  <ListItemText
                    primary={option.company_name}
                    sx={{
                      fontFamily: 'Open Sans',
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '20px',
                    }}
                  />
                </MenuItem>
              ))}
            </AccordionDetails>
          </Accordion>

          <Box
            sx={{
              borderTop: '1px solid #E0E0E0',
              minHeight: '36px',
              p: 2,
              bgcolor: '#FFFFFF',
              position: 'sticky',
              bottom: 0,
              display: 'flex',
              justifyContent: 'left',
            }}
          >
            <Button
              ref={firstFocusableRef}
              variant="contained"
              size="small"
              sx={{
                textTransform: 'none',
                height: "44px",
                borderRadius: "1.5rem",
                px: "2rem",
                fontFamily: "Open Sans",
                fontWeight: 700,
                fontSize: "16px",
                lineHeight: "20px",
              }}
              onClick={handleExportSubmit}
            >
              Export
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};
export default SubSellerList;
